import React from "react";
import { Link, NavLink } from "react-router-dom";

const Navbar = () => {
  const baseUrl =
    window.CARLOCA_UPLOADS + "/users/";

  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };
  const storedUserPreferences = getDataFromlocalStorage("userData");
  return (
    <>
      <nav className="navbar bg-white fixed-top">
        <div className="container">
          <Link to="/" className="navbar-brand d-flex align-items-center me-4">
            <img src="/img/logo.png" style={{ width: "50px" }} alt="" />
            <h3 className="m-0  ms-1">Carloca</h3>
          </Link>
          {storedUserPreferences !== null && (
            <div className="d-flex">
              <Link to="/give-feedback" className="nav-link fw-bolder d-none d-sm-flex align-items-center me-3 text-primary">
                Feedback <i className="fas fa-comment-alt mx-2 d-md-block d-none"></i>
              </Link>
              <div className="nav-item dropdown ms-auto me-2">
                <Link
                  className="nav-link dropdown-toggle d-flex flex-column"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <div
                    style={{
                      height: "2.3rem",
                      width: "2.3rem",
                      border: "2px solid #ddd",
                      borderRadius: "50%",
                    }}
                  >
                    <img
                      src={
                        storedUserPreferences?.profile !== null &&
                          storedUserPreferences?.profile !== undefined
                          ? `${baseUrl}${storedUserPreferences?.profile}`
                          : "/img/user_default.png"
                      }
                      style={{
                        objectFit: "fill",
                        objectPosition: "center",
                        borderRadius: "50%",
                      }}
                      className="h-100 w-100"
                      alt="user profile"
                    />
                  </div>
                  <h6
                    className="fw-semibold mb-0 pb-0"
                    style={{ fontSize: "12px" }}
                  >
                    {storedUserPreferences?.first_name}
                  </h6>
                </Link>
                <ul className="dropdown-menu rounded-0">
                  <li>
                    {storedUserPreferences?.role === "dealer" ? (
                      <Link
                        to="/dealer/store"
                        state={{ owner_id: storedUserPreferences?.id }}
                        className="dropdown-item"
                      >
                        My Profile
                      </Link>
                    ) : (
                      <Link to="/profilesetting" className="dropdown-item">
                        My Profile
                      </Link>
                    )}
                  </li>

                  <li>
                    <Link to="/logout" className="dropdown-item">
                      Logout
                    </Link>
                  </li>
                </ul>
              </div>

              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasNavbar"
                aria-controls="offcanvasNavbar"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
            </div>
          )}
          {storedUserPreferences == null && (
            <div className="d-flex">
              <Link to="/give-feedback" className="nav-link fw-bolder d-none d-sm-flex align-items-center me-3 text-primary">
                Feedback <i className="fas fa-comment-alt mx-2 d-md-block d-none"></i>
              </Link>
              <Link to="/login" className="nav-link fw-bolder text-primary">
                Login <i className="fa-solid fa-lock ml-2"></i>
              </Link>
            </div>
          )}

          <div
            className="offcanvas offcanvas-end shadow"
            tabIndex="-1"
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
            style={{ width: "350px", borderLeft: "none" }}
            data-bs-scroll="false"
          >
            <div className="offcanvas-header align-items-center py-2 px-4" style={{ borderBottom: "1px solid rgba(0, 136, 156, 0.15)", backgroundColor: "#fcfcfd" }}>
              <div className="d-flex align-items-center">
                <img src="/img/logo.png" style={{ height: "32px", width: "auto" }} alt="Carloca Logo" />
                <h5 className="offcanvas-title ms-2 mb-0 fw-bolder" id="offcanvasNavbarLabel" style={{ color: "#00889c", letterSpacing: "0.5px" }}>
                  Carloca
                </h5>
              </div>
              <button
                type="button"
                className="btn-close shadow-none"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className="offcanvas-body px-0 pt-0 d-flex flex-column" style={{ overflowY: "auto" }}>
              <div className="profile-section text-center py-3 mb-1" style={{ borderBottom: "1px solid #e2e8f0", backgroundColor: "#fff" }}>
                <div style={{ position: "relative", display: "inline-block", marginBottom: "12px" }}>
                  <img
                    className="profile_img shadow-sm"
                    src={
                      storedUserPreferences?.profile !== null &&
                        storedUserPreferences?.profile !== undefined
                        ? `${baseUrl}${storedUserPreferences?.profile}`
                        : "/img/user_default.png"
                    }
                    style={{ height: "72px", width: "72px", borderRadius: "50%", objectFit: "cover", border: "2px solid #fff", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
                    alt="User Profile"
                  />
                </div>
                <h6 className="fw-bold text-dark mb-1" style={{ fontSize: "16px" }}>
                  {storedUserPreferences?.first_name} {storedUserPreferences?.last_name || ""}
                </h6>
                <p className="text-muted mb-3" style={{ fontSize: "12px", fontWeight: "500" }}>{storedUserPreferences?.role === "dealer" ? "Dealer Account" : "Private Account"}</p>
                {storedUserPreferences?.role === "dealer" ? (
                  <div className="d-flex flex-wrap justify-content-center gap-2 px-3 w-100">
                    <Link
                      to="/edit/dealer/profile"
                      className="btn btn-outline-primary btn-sm rounded-pill px-3"
                      style={{ fontSize: "13px", fontWeight: "500" }}
                    >
                      <i className="fa-solid fa-pen-to-square me-1"></i> Edit
                    </Link>
                    <Link
                      to="/dealer/store"
                      state={{ owner_id: storedUserPreferences?.id }}
                      className="btn btn-primary btn-sm rounded-pill px-3"
                      style={{ fontSize: "13px", fontWeight: "500" }}
                    >
                      <i className="fa-solid fa-store me-1"></i> View Store
                    </Link>
                  </div>
                ) : (
                  <Link
                    to="/profilesetting"
                    className="btn btn-outline-primary btn-sm rounded-pill px-4"
                    style={{ fontSize: "13px", fontWeight: "500" }}
                  >
                    <i className="fa-solid fa-user-pen me-1"></i> Edit Profile
                  </Link>
                )}
              </div>
              <div className="px-3 pb-4">
                {storedUserPreferences?.role === "user" ? (
                  <ul className="navbar-nav justify-content-end flex-grow-1">
                    <h6
                      className="mt-3 mb-1 fw-bold text-uppercase px-2"
                      style={{ fontSize: "11px", letterSpacing: "1px", color: "#94a3b8" }}
                    >
                      Selling
                    </h6>
                    <li className="nav-item">
                      <NavLink to="/mylisting" className="nav-link">
                        <i className="fa-solid fa-list"></i> My Listing
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/offers" className="nav-link">
                        <i className="fa-solid fa-tags"></i> Offers
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/apprequests" className="nav-link">
                        <i className="fa-solid fa-check-circle"></i> Approved Offers
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/rejectedrequests" className="nav-link">
                        <i className="fa-solid fa-times-circle"></i> Rejected Offers
                      </NavLink>
                    </li>
                    <h6
                      className="mt-3 mb-1 fw-bold text-uppercase px-2"
                      style={{ fontSize: "11px", letterSpacing: "1px", color: "#94a3b8" }}
                    >
                      Buying
                    </h6>
                    <li className="nav-item">
                      <NavLink to="/pendingunlocks" className="nav-link">
                        <i className="fa-solid fa-lock-open"></i> Pending Unlocks
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/unlockedcars" className="nav-link">
                        <i className="fa-solid fa-car"></i> Unlocked Cars
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/declined-request" className="nav-link">
                        <i className="fa-solid fa-ban"></i> Declined Offers
                      </NavLink>
                    </li>
                    <div className="styled-hr mx-3 my-2" style={{ borderColor: "#e2e8f0" }}></div>
                    <li className="nav-item">
                      <NavLink to="/mycredits" className="nav-link">
                        <i className="fa-solid fa-coins"></i> My Credits
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/fav" className="nav-link">
                        <i className="fa-solid fa-heart"></i> Favourites
                      </NavLink>
                    </li>
                  </ul>
                ) : (
                  <ul className="navbar-nav justify-content-end flex-grow-1">
                    <li className="nav-item">
                      <NavLink
                        to="/dealer/dashboard"
                        className="nav-link px-3 py-2 fw-semibold d-flex align-items-center rounded-3 mb-1"
                      >
                        <i className="fa-solid fa-chart-pie"></i> My Dashboard
                      </NavLink>
                    </li>

                    <h6
                      className="mt-3 mb-1 fw-bold text-uppercase px-2"
                      style={{ fontSize: "11px", letterSpacing: "1px", color: "#94a3b8" }}
                    >
                      Selling
                    </h6>
                    <li className="nav-item ">
                      <NavLink to="/dealer/my-inventory" className="nav-link">
                        <i className="fa-solid fa-list"></i> My Inventory
                      </NavLink>
                    </li>
                    <li className="nav-item ">
                      <NavLink to="/dealer/all-offers" className="nav-link">
                        <i className="fa-solid fa-tags"></i> Offers
                      </NavLink>
                    </li>

                    <h6
                      className="mt-3 mb-1 fw-bold text-uppercase px-2"
                      style={{ fontSize: "11px", letterSpacing: "1px", color: "#94a3b8" }}
                    >
                      Buying
                    </h6>

                    <li className="nav-item ">
                      <NavLink to="/dealer/pending-unlocks" className="nav-link">
                        <i className="fa-solid fa-lock-open"></i> Pending Unlocks
                      </NavLink>
                    </li>
                    <li className="nav-item ">
                      <NavLink to="/dealer/unlocked-cars" className="nav-link">
                        <i className="fa-solid fa-car"></i> Unlocked Cars
                      </NavLink>
                    </li>
                    <li className="nav-item ">
                      <NavLink to="/dealer/decline-offers" className="nav-link">
                        <i className="fa-solid fa-ban"></i> Declined Offers
                      </NavLink>
                    </li>
                    <div className="styled-hr mx-3 my-2" style={{ borderColor: "#e2e8f0" }}></div>
                    <li className="nav-item ">
                      <NavLink to="/mycredits" className="nav-link">
                        <i className="fa-solid fa-coins"></i> My Credits
                      </NavLink>
                    </li>
                  </ul>
                )}

                <div className="mt-auto pt-3 pb-2 text-center w-100">
                  <Link to="/logout" className="btn btn-light text-danger fw-bold rounded-pill px-4 shadow-sm border">
                    <i className="fa-solid fa-arrow-right-from-bracket me-2"></i>Logout
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
